import { Component, inject } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import {
  MAT_DIALOG_DATA,
  MatDialogActions,
  MatDialogClose,
  MatDialogContent,
  MatDialogTitle,
} from '@angular/material/dialog';

@Component({
  selector: 'tgrid-national-access-confirmation-modal',
  standalone: true,
  imports: [
    MatButtonModule,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    MatDialogTitle,
  ],
  templateUrl: './national-access-confirmation-modal.component.html',
  styleUrls: ['../../../../../style/modal.scss'],
})
export class NationalAccessConfirmationModalComponent {
  protected readonly data = inject<{ userName: string }>(MAT_DIALOG_DATA);
}
